import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onsubmit"]
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = { class: "text-start mb-1" }
const _hoisted_4 = {
  class: "h6 mb-0",
  for: "inputLogin"
}
const _hoisted_5 = { class: "input-group mb-2 w-100 position-relative" }
const _hoisted_6 = { class: "text-start mb-1" }
const _hoisted_7 = {
  class: "h6 mb-0",
  for: "inputPassword"
}
const _hoisted_8 = { class: "input-group mb-2 w-100 position-relative" }
const _hoisted_9 = { class: "input-hint text-muted small text-start" }
const _hoisted_10 = {
  type: "submit",
  class: "btn btn-secondary w-100 mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onsubmit: _ctx.onSubmit,
    class: "position-relative"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("hello.login.room.num", { room: _ctx.$t(`change.room.${_ctx.$hotel}`, 2) })), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "input-group-text rounded-0 rounded-start bg-transparent" }, [
          _createElementVNode("i", { class: "bi bi-person" })
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control z-0 phone-input",
          id: "inputLogin",
          placeholder: "221",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.login) = $event))
        }, null, 512), [
          [_vModelText, _ctx.login]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("hello.login.room.pass")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "input-group-text rounded-0 rounded-start bg-transparent" }, [
          _createElementVNode("i", { class: "bi bi-lock" })
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control z-0 phone-input",
          id: "inputPassword",
          placeholder: "XXXX",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("hello.login.room.hint")), 1)
    ]),
    _createElementVNode("button", _hoisted_10, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("app.onLogin")), 1)
    ])
  ], 8, _hoisted_1))
}